import Vue from "vue";
import Vuex from "vuex";

const host = "https://hamilton.corp.modedesigns.com";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    orders: [],
    cursor: "",
    noMoreOrders: false,
    picklist: {},
    products: [],
    picklistVariants: [],
    selectedVariant: undefined
  },
  mutations: {
    APPEND_PICKLIST_VARIANTS(state, variants) {
      for (var variant of variants) {
        let index = state.picklistVariants.findIndex(v => v.id === variant.id);
        if (index != -1) {
          state.picklistVariants[index] = variant;
          state.picklistVariants = [...state.picklistVariants];
        } else {
          state.picklistVariants.push(variant);
        }
      }
    },
    REMOVE_PICKLIST_VARIANTS(state, variants) {
      for (var variant of variants) {
        let index = state.picklistVariants.findIndex(v => v.id === variant);
        if (index != -1) {
          state.picklistVariants.splice(index, 1);
          state.picklistVariants = [...state.picklistVariants];
        }
      }
    },
    CLEAR_SELECTED_VARIANT(state) {
      state.selectedVariant = undefined;
    },
    SET_ORDERS(state, orders) {
      state.orders = orders;
    },
    SET_PRODUCTS(state, products) {
      state.products = products.edges.map(e => e.node);
    },
    INSERT_VARIANTS(state, product) {
      console.log("inserting variants", product);
      product.variants = product.variants.edges.map(v => v.node || v);
      let index = state.products.findIndex(p => p.id === product.id);
      state.products[index] = product;
      state.products = [...state.products];
    },
    SET_SELECTED_VARIANT(state, product) {
      product.variants = product.variants.edges
        ? product.variants.edges.map(v => v.node || v)
        : product.variants.map(v => v.node || v);
      state.selectedVariant = product;
    },
    SET_PICKLIST_VARIANTS(state, picklistVariants) {
      state.picklistVariants = picklistVariants;
    },
    APPEND_ORDERS(state, orders) {
      state.orders = state.orders.concat(orders);
    },
    REMOVE_ORDER(state, orderId) {
      let index = state.orders.findIndex(o => o.id === orderId);
      if (index !== -1) {
        state.orders.splice(index, 1);
      }
    },
    SET_ORDER_PAGINATION(state, cursor) {
      state.cursor = cursor;
    },
    SET_NO_MORE_ORDERS(state, hasNextPage) {
      state.noMoreOrders = !hasNextPage;
    },
    SET_PICKLIST(state, picklist) {
      state.picklist = picklist;
    },
    CLEAR_PICKLIST(state) {
      state.picklist = {};
    }
  },
  actions: {
    addProduct({ commit, state }) {
      return Vue.axios
        .post(`${host}/api/graph`, {
          query
        })
        .then(response => {
          console.log("picklist products graph response", response);
          if (!response.data.products) return;
          commit(
            "SET_PRODUCTS",
            response.data.products.edges
              .map(e => e.node)
              .filter(p => !existingProducts.includes(p.id))
          );
        })
        .catch(errorResponse => {
          console.log("Error", errorResponse);
          return;
        });
    },
    getOrdersGraph({ commit, state }, variables) {
      const query = `query ($numOrders: Int!, $cursor: String, $query: String) {
              orders(first: $numOrders, after: $cursor, sortKey: CREATED_AT, query: $query) {
                  pageInfo {
                      hasNextPage
                      hasPreviousPage
                  }
                  edges {
                      cursor
                      node {
                          fulfillable
                          legacyResourceId
                          name
                          tags
                          note
                          customer {
                              firstName
                              lastName
                              email
                              id
                              locale
                              numberOfOrders
                              orders(first: 10, query: "status:'open'") {
                                  edges {
                                      node {
                                          id
                                      }
                                  }
                              }
                          }
                          lineItems(first: 25) {
                              edges {
                                  node {
                                      name
                                      fulfillableQuantity
                                      fulfillmentStatus
                                  }
                              }
                          }
                      }
                  }
              }
            }
            `;
      if (variables.query) {
        variables.query = `${variables.query} AND status:'open' AND (fulfillment_status:'unfulfilled' OR fulfillment_status:'partial')`;
      } else {
        variables.query = `status:'open' AND (fulfillment_status:'unfulfilled' OR fulfillment_status:'partial')`;
      }
      return Vue.axios
        .post(`${host}/api/graph`, {
          query,
          variables
        })
        .then(response => {
          if (!response.data.orders) return;
          let firstPage = !response.data.orders.pageInfo.hasPreviousPage;
          let mutation = firstPage ? "SET_ORDERS" : "APPEND_ORDERS";
          let orders = response.data.orders.edges.map(o => {
            o.node.lineItems = o.node.lineItems.edges.map(l => {
              return {
                ...l.node
              };
            });
            let order = o.node;
            order.customer.numberOfOrders = order.customer.orders.edges.length;
            return {
              ...order,
              id: order.legacyResourceId
            };
          });
          if (response.data.orders.edges.length) {
            const cursor =
              response.data.orders.edges[response.data.orders.edges.length - 1]
                .cursor;
            commit("SET_ORDER_PAGINATION", cursor);
          }
          commit(mutation, orders);
          commit(
            "SET_NO_MORE_ORDERS",
            response.data.orders.pageInfo.hasNextPage
          );
        })
        .catch(errorResponse => {
          console.log("Error", errorResponse);
          return;
        });
    },
    getPicklistVariants({ commit, state }) {
      console.log("getPicklistVariants");
      return Vue.axios
        .get(`${host}/api/variants`)
        .then(response => {
          commit("SET_PICKLIST_VARIANTS", response.data || []);
        })
        .catch(() => {
          console.log("could not fetch orders");
          return;
        });
    },
    getProducts({ commit, state }) {
      const query = `query {
            products(first: 250, query: "status:active OR status:draft"  sortKey: CREATED_AT, reverse: true) {
                edges {
                    node {
                        id
                        title
                        productType
                        tags
                    }
                }
            }
        }`;

      return Vue.axios
        .post(`${host}/api/graph`, {
          query
        })
        .then(response => {
          console.log("products graph response", response);
          if (!response.data.products) return;
          commit("SET_PRODUCTS", response.data.products);
        })
        .catch(errorResponse => {
          console.log("Error", errorResponse);
          return;
        });
    },
    getSelectedVariant({ commit, state }, variables) {
      const query = `query ($id: ID!) {
            product(id: $id) {
                title
                id
                productType
                tags
                variants(first:100) {
                    edges {
                        node {
                            id
                            title
                            displayName
                            barcode
                            sku
                            product {
                                productType
                                id
                                title
                            }
                        }
                    }
                }
            }
        }
        `;

      return Vue.axios
        .post(`${host}/api/graph`, {
          query,
          variables
        })
        .then(response => {
          console.log("product graph response", response);
          if (!response.data.product) return;
          commit("SET_SELECTED_VARIANT", response.data.product);
        })
        .catch(errorResponse => {
          console.log("Error", errorResponse);
          return;
        });
    },
    getVariants({ commit, state }, variables) {
      const query = `query ($id: ID!) {
            product(id: $id) {
                title
                id
                productType
                tags
                variants(first:100) {
                    edges {
                        node {
                            id
                            title
                            displayName
                            barcode
                            sku
                            metafields (first:1, namespace: "fulfillment") {
                              edges {
                                node {
                                  namespace
                                  value
                                }
                              }
                            }
                            product {
                                productType
                                id
                                title
                            }
                        }
                    }
                }
            }
        }
        `;

      return Vue.axios
        .post(`${host}/api/graph`, {
          query,
          variables
        })
        .then(response => {
          if (!response.data.product) return;
          commit("INSERT_VARIANTS", response.data.product);
        })
        .catch(errorResponse => {
          console.log("Error", errorResponse);
          return;
        });
    },
    setSelectedVariant({ commit, state }, product) {
      commit("SET_SELECTED_VARIANT", product);
    },
    clearSelectedVariant({ commit, state }) {
      commit("CLEAR_SELECTED_VARIANT");
    },
    removeOrder({ commit, state }, orderId) {
      commit("REMOVE_ORDER", orderId);
    },
    getPickList({ commit, state }, orderId) {
      return Vue.axios
        .get(`${host}/api/picklist?order_id=${orderId}`)
        .then(response => {
          commit("SET_PICKLIST", response.data);
        })
        .catch(() => {
          commit("SET_PICKLIST", {});
          throw "could not fetch picklist";
        });
    },
    updatePickList({ commit, state }, picklist) {
      return Vue.axios
        .post(`${host}/api/picklist`, {
          picklist
        })
        .then(response => {
          console.log("updated picklist", response.data);
          commit("SET_PICKLIST", response.data);
        })
        .catch(() => {
          console.log("could not update picklist");
          return;
        });
    },
    updatePicklistVariants({ commit, state }, variants) {
      return Vue.axios
        .post(`${host}/api/variants`, {
          variants
        })
        .then(response => {
          console.log("updated variant", response);
          commit("APPEND_PICKLIST_VARIANTS", response.data);
        })
        .catch(() => {
          console.log("could not update variant");
          return;
        });
    },
    deletePicklistVariants({ commit, state }, variants) {
      return Vue.axios
        .post(`${host}/api/variants/delete`, {
          variants
        })
        .then(response => {
          console.log("updated variant", response);
          commit("REMOVE_PICKLIST_VARIANTS", response.data);
        })
        .catch(e => {
          console.log("could not update variant", e);
          return;
        });
    },
    clearPicklist({ commit }) {
      commit("CLEAR_PICKLIST");
    }
  },
  modules: {}
});
